import Base from './Base';
import { ApiResponse, ListParams, TotalListMeta } from '@/types/api';
import { SurveyAnswer, SurveyAnswerList } from '@/types/survey';

export type SurveyAnswerPayload = {
  name: string;
  answers: SurveyAnswer[];
};

export interface SurveyAnswerListParams extends ListParams {
  questionIds?: number[];
  surveyName?: string;
  surveyId?: number;
}

class Survey extends Base {
  async saveAnswers(payload: SurveyAnswerPayload) {
    const response = await this.apiClient.post('/survey/answers', payload);

    return response.data;
  }

  async listAnswers(params: SurveyAnswerListParams) {
    const response = await this.apiClient.get<ApiResponse<SurveyAnswerList[], TotalListMeta>>(
      '/survey/answers',
      {
        params,
      },
    );

    return response.data;
  }

  async setSelectedTags(tagNames: string[]) {
    const response = await this.apiClient.post('/social/tags/select', {
      tagNames,
    });

    return response;
  }
}

export default Survey;
